import { render } from "./ConsentItem.vue?vue&type=template&id=c4d9d148&scoped=true"
import script from "./ConsentItem.vue?vue&type=script&lang=js"
export * from "./ConsentItem.vue?vue&type=script&lang=js"

import "./ConsentItem.vue?vue&type=style&index=0&id=c4d9d148&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d9d148"]])

export default __exports__